
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/interior",
      function () {
        return require("private-next-pages/interior/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/interior"])
      });
    }
  